export function getAccountId(siteId) {
    return new Promise((resolve, reject) => {
        fetch(
            '/api/resource/facebook-analytics-site/' + encodeURIComponent(siteId),
            {credentials: 'same-origin'}
        ).then((response) => {
            if (response.status !== 200) {
                //If 404 just return blank accountId
                resolve('');
            } else if (response.status !== 200) {
                reject(response);
            }
            return response.json();
        }).then(function (data) {
            if (data) {
                resolve(data.accountId);
            } else {
                reject('no data in response from server');
            }
        });
    });
}

export function setAccountId(siteId, accountId) {
    return new Promise((resolve, reject) => {
        fetch(
            '/api/resource/facebook-analytics-site',
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({siteId: siteId, accountId: accountId}),
                credentials: 'same-origin',
            }
        ).then((response) => {
            if (response.status !== 200) {
                reject(response);
            }
            return response.json();
        }).then((data) => {
            resolve(data);
        });
    });
}
